import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { getSelectedAccountType } from "containers/Accounts/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as createReducer from "containers/CreateWizard/reducer";
import * as runReducer from "containers/Run/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as deployReducer from "containers/Deploy/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";
import * as predictReducer from "containers/Predict/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as recipeReducer from "containers/Recipe/reducer";
import * as projectReducer from "containers/Project/reducer";

import TestPredictions from "components/UnifiedProject/TestPredictions/TestPredictions";
import NextTestPredictions from "components/Next/TestPredictions/TestPredictions";

class TestPredictionsContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { deploy: false };

    props.initPredict();
  }

  render() {
    const {
      id,
      model,
      models,
      isDeploy,
      bestModel,
      isError,
      isShow,
      step,
      index,
      fieldSelect,
      originalId,
      blueprintId,
      isNext
    } = this.props;

    return isNext ? <NextTestPredictions {...this.props} /> : <TestPredictions {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  initJob: () => {},

  updateChooseModel: (model) => dispatch(runReducer.updateFeatureSelection(ownProps.id, model, true)),
  updateDeploy: () => dispatch(runReducer.toggleDeploy(ownProps.id)),
  updateShowDeploy: (showDeploy) => dispatch(runReducer.updateShowDeploy(ownProps.id, showDeploy)),
  updateImpact: (impactType, impact) => dispatch(setupReducer.updateImpact(ownProps.id, impactType, impact)),
  resetDefaults: () => dispatch(setupReducer.resetDefaults(ownProps.id)),
  updateFieldSelect: (fieldSelect) => dispatch(runReducer.updateFieldSelect(ownProps.id, fieldSelect)),
  updateValueSelect: (valueSelect) => dispatch(runReducer.updateValueSelect(ownProps.id, valueSelect)),
  updateIsFeatureOpen: (isOpen) => dispatch(loginReducer.updateIsFeatureOpen(isOpen)),
  updateProcessLimit: (processLimit) => dispatch(setupReducer.updateProcessLimit(ownProps.id, processLimit)),
  updateProcessLimitPct: (processLimitPct) =>
    dispatch(setupReducer.updateProcessLimitPct(ownProps.id, processLimitPct)),
  updateIsNextStep: (isNextStep) => dispatch(runReducer.updateIsNextStep(ownProps.id, isNextStep)),

  testPredict: () => dispatch(deployReducer.testPredict(ownProps.id)),

  handleRestfulDeploy: (modelId) => dispatch(deploymentsReducer.handleRestfulDeploy(ownProps.id, modelId)),
  stopDeploy: (deployId) => dispatch(deploymentsReducer.stopDeploy(deployId)),

  initPredict: () => dispatch(predictReducer.init(ownProps.id))
});

const mapStateToProps = (state, ownProps) => {
  const models = runReducer.getTransformedSortedModels(state, ownProps.id);
  const bestModel = models && models.length > 0 ? models[0] : undefined;
  const selModel = runReducer.getSelModel(state, ownProps.id);

  const deployRecipeId = blueprintReducer.getDeployRecipeId(state, setupReducer.getBlueprintId(state, ownProps.id));

  let optimized = ownProps.optimized;
  if (!optimized || optimized.projectId !== ownProps.projectId) {
    optimized = projectReducer.getOptimized(state, ownProps.projectId);
  }

  console.log(optimized);

  return {
    step: createReducer.getStep(state),
    isForecast: setupReducer.getIsForecast(state, ownProps.id),
    models: models,
    model: selModel,
    bestModel: bestModel,
    fieldSelect: runReducer.getFieldSelect(state, ownProps.id),
    isDeploy: runReducer.getIsDeploy(state, ownProps.id),
    isError: runReducer.getIsError(state, ownProps.id),
    errorMessages: runReducer.getErrors(state, ownProps.id),
    cloudURL: runReducer.getCloudURL(state, ownProps.id),
    showDeploy: runReducer.getShowDeploy(state, ownProps.id),
    labels: setupReducer.getLabels(state, ownProps.id),
    netImpactLabel: setupReducer.getNetImpactLabel(state, ownProps.id),
    isDefaultImpacts: setupReducer.getIsDefaultImpacts(state, ownProps.id),
    selectedDataset: setupReducer.getDatasetFromSetup(state, ownProps.id),
    isContinuous: setupReducer.getOutcomeType(state, ownProps.id) === "number",
    isTwoMinuteRun: setupReducer.getIsTwoMinuteRun(state, ownProps.id),
    isQuickRun: setupReducer.getIsQuickRun(state, ownProps.id),
    fieldNames: setupReducer.getFieldNames(state, ownProps.id),
    processLimit: setupReducer.getProcessLimit(state, ownProps.id),
    setupChanged: setupReducer.getSetupChanged(state, ownProps.id),
    deployment: deploymentsReducer.getDeployment(state, ownProps.id, selModel && selModel.id),
    selectedAccountType: getSelectedAccountType(state),
    relatedJobs: runReducer.getRelatedJobs(state, ownProps.id),
    deployRecipeId: deployRecipeId,
    deployRecipeName: recipeReducer.getRecipeName(state, deployRecipeId),
    isEditBlueprint: blueprintReducer.getIsEditing(state, ownProps.blueprintId),

    trueAction: setupReducer.getTrueAction(state, ownProps.id, true),

    isNextStep: runReducer.getIsNextStep(state, ownProps.id),
    frontierModels: runReducer.getFrontierList(state, ownProps.id),

    optimized: optimized,
    isOverallSegment: projectReducer.getIsOverallSegment(state, ownProps.projectId, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(TestPredictionsContainer);
